module.exports = __webpack_public_path__ + "media/images/FWD-Mobile-Banner-3f598e2ab903ae2aff2213a19d08f82e.png";